import { Link } from "react-router-dom";
import { useGetSettingQuery } from "../../../../Redux/Apis/siteApi";
import { fa_currency } from "../../../../utils/PersianNum";

function Products() {
    const {data : {home: {products : {data,name,caption}}}} = useGetSettingQuery()

    return ( 
        <div className="product-section mt-150 mb-150">
            <div className="container">
                <div className="row">
                    <div className="col-lg-8 offset-lg-2 text-center">
                        <div className="section-title">	
                            {name && <h3><span className="orange-text">{name.split(" ")[0]}</span> {name.split(" ").slice(1).join(" ")}</h3>}
                            {caption && <p>{caption}</p>}
                        </div>
                    </div>
                </div>

                <div className="row">
                    {data.lso_products && data.lso_products.map((row,index) => 
                        <div className="col-lg-4 col-md-6 text-center" key={index}>
                            <div className="single-product-item">
                                <div className="product-image">
                                    <Link to={"/product/" + row.txt_id} >
                                        <img src={row.img_image} alt="product"/>
                                    </Link>
                                </div>
                                <h3>{row.txt_name}</h3>
                                <p className="product-price"><span>{row.txt_excerpt}</span>
                                 {fa_currency(row.num_price) } تومان</p>
                                <Link to={"/product/" + row.txt_id} className="cart-btn">
                                    <i className="fas fa-shopping-cart"></i>مشاهده و خرید
                                </Link>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
     );
}

export default Products;    